<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4 text-truncate">Add New Shipping Method
            {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4 text-truncate"> View Shipping Method - {{ this.inputName }}</h6>
        <h6 v-else class="heading-small text-muted mb-4 text-truncate">Edit Shipping Method - {{ this.inputName }}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
            <b-tab title="Details" active v-on:click="openDetails"></b-tab>
            <b-tab title="History" v-on:click="openHistory">
                <b><label>Created By: </label></b>
                {{ inputCreatedBy || "System" }} | {{ inputCreatedAt | dateFilter }}
                <br>
                <b><label>Updated By:</label></b>
                {{ inputUpdatedBy || "System" }} | {{ inputUpdatedAt | dateFilter }}
            </b-tab>
        </b-tabs>

        <form id="form-proper">
            <fieldset v-if="customFormMode == 1" v-show="showDetails">
                <base-input alternative="" label="Code" placeholder="" v-model="inputCode"
                    input-classes="form-control" :disabled="disableInput" />
                <base-input alternative="" label="Name" placeholder="" v-model="inputName" input-classes="form-control"
                    required :disabled="disableInput" />
                <base-input alternative="" label="Shipping Type" required>
                    <a-select style="width: 100%" placeholder="Enter shipping type" v-model="inputShippingType" :disabled="disableInput" >
                        <a-select-option v-for="option in shippingTypeOptions" :key="option.key" :value="option.key">
                            {{ option.value }}</a-select-option>
                    </a-select>
                    <!-- <select style="width: 100%" placeholder="Enter shipping type" v-model="inputShippingType">
                        <option v-for="option in shippingTypeOptions" :key="option.key" :value="option.key">
                            {{ option.value }}
                        </option>
                    </select> -->
                </base-input>

                <!-- <base-input label="Shipping Type" size="lg" required>
                    <select class="form-control" v-model="inputShippingType">
                        <option v-for="option in shippingTypeOptions" v-bind:value="option.key" :key="option.key">
                            {{ option.value }}
                        </option>
                    </select>
                </base-input> -->
                <base-input alternative="" label="Carrier" placeholder="" v-model="inputCarrier"
                    input-classes="form-control" required :disabled="disableInput" />
                <base-input alternative="" label="Carrier Account" placeholder="" v-model="inputCarrierAccount"
                    input-classes="form-control" required :disabled="disableInput" />
                <base-input alternative="" label="Contact Person" placeholder="" v-model="inputContactPerson"
                    input-classes="form-control" required :disabled="disableInput" />
                <base-input alternative="" label="Phone" placeholder="" v-model="inputPhone"
                    input-classes="form-control" :disabled="disableInput" />
                <base-input alternative="" label="Remark"  >
                    <textarea rows="4" class="form-control" v-model="inputRemark" :disabled="disableInput" />
                </base-input>
            </fieldset>
            <div v-if="customFormMode == 2">
                <!-- Override -->
                <dynamic-form :convertedJson="{ mode: customForm.mode, groups: customForm.groups }"
                    :formSettings="shipping_method" @valueUpdated="updateSettings" :key="dynamicFormKey" />
            </div>
            <div v-if="customFormMode == 3">
                <!-- Append -->
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="inputCode"
                            input-classes="form-control" />
                        <base-input alternative="" label="Name" placeholder="" v-model="inputName"
                            input-classes="form-control" required />
                        <base-input label="Shipping Type" size="lg" required>
                            <select class="form-control" v-model="inputShippingType">
                                <option v-for="option in shippingTypeOptions" v-bind:value="option.key"
                                    :key="option.key">
                                    {{ option.value }}
                                </option>
                            </select>
                        </base-input>
                        <base-input alternative="" label="Carrier" placeholder="" v-model="inputCarrier"
                            input-classes="form-control" required />
                        <base-input alternative="" label="Carrier Account" placeholder="" v-model="inputCarrierAccount"
                            input-classes="form-control" required />
                        <base-input alternative="" label="Contact Person" placeholder="" v-model="inputContactPerson"
                            input-classes="form-control" required />
                        <base-input alternative="" label="Phone" placeholder="" v-model="inputPhone"
                            input-classes="form-control" />
                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="inputRemark" />
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="2" forceRender>
                        <dynamic-form :convertedJson="{ mode: customForm.mode, groups: customForm.groups_append }"
                            :formSettings="shipping_method" @valueUpdated="updateSettings" :key="dynamicFormKey"
                            :showErrors="false" />
                    </a-tab-pane>
                </a-tabs>
            </div>

            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'"
                    style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right"
                        @click.prevent="create">Add</button>
                    <button v-else type="button" class="btn btn-primary float-right"
                        @click.prevent="update">Update</button>
                </div>
                <div v-else
                    style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right"
                        @click.prevent="$emit('closeDrawer', null)">Close</button>
                </div>
            </div>
        </form>
    </div>
</template>


<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import ValidateField from '../../components/validateFormUtils.js'
import DynamicForm from '../DynamicForm.vue'
import { mapState } from 'vuex'
import moment from 'moment'
var component_x;
export default {
    components: {
        DynamicForm
    },
    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType']),
    },
    mounted: async function () {
        // Meta-data Call
        const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Shipping Method?field_name=name', null)
        const sytemModuleId = sytemModule.id
        const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id', null)
        if (this.isJsonString(accSystemModuleRequest.meta) == true) {
            const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
            if (accSystemModule != null) {
                if (accSystemModule.form_mode != undefined) {
                    this.customFormMode = accSystemModule.form_mode
                }
                if (accSystemModule.customized_forms != undefined) {
                    this.customForm = accSystemModule.customized_forms
                }
            }
        }

        if (this.serverType == 'branch') {
            this.disableInput = true;
            // var form = document.getElementById("form-proper")
            // var elements = form.elements;
            // for (var i = 0, len = elements.length; i < len; ++i) {
            //     elements[i].disabled = true;
            // }
        } else {
            if (this.$attrs.viewMode == true) {
                this.disableInput = true;
                // var form = document.getElementById("form-proper")
                // var elements = form.elements;
                // console.log(elements);
                // for (var i = 0, len = elements.length; i < len; ++i) {
                //     elements[i].disabled = true;
                //     console.log(elements[i]);

                // }
            }
        }
        component_x = this
        if (component_x.profileId > 0) {
            var data = await HTTPRequest.getRequest(component_x.endPoint + 'shipping_methods/' + component_x.profileId, null)
            if (data == undefined) {
                component_x.$router.go()
            } else {
                if (data["error"] == undefined) {
                    component_x.inputCode = data["code"]
                    component_x.inputName = data["name"]
                    component_x.inputShippingType = data["shipping_type"]
                    component_x.inputCarrier = data["carrier"]
                    component_x.inputCarrierAccount = data["carrier_account"]
                    component_x.inputContactPerson = data["contact_person"]
                    component_x.inputPhone = data["phone"]
                    component_x.inputRemark = data["remark"]
                    component_x.inputCreatedBy = data["created_by"]
                    component_x.inputCreatedAt = data["created_at"]
                    component_x.inputUpdatedBy = data["updated_by"]
                    component_x.inputUpdatedAt = data["updated_at"]
                } else {
                    this.errors = data["error"].split(",") //format will change when error message has comma
                    //component_x.$router.push("/")
                }
            }
        }
        this.dynamicFormKey++;
    },
    data: function () {
        return {
            inputCode: '',
            inputName: '',
            inputShippingType: '',
            shippingTypeOptions: [
                { key: "D", value: "Delivery" },
                { key: "P", value: "Pick-up" }
            ],
            showDetails: true,
            inputCarrier: '',
            inputCarrierAccount: '',
            inputContactPerson: '',
            inputPhone: '',
            inputRemark: '',
            inputCreatedBy: '',
            inputCreatedAt: '',
            inputUpdatedBy: '',
            inputUpdatedAt: '',
            errors: [],
            // FOR META-DATA
            customFormMode: 1,
            customForm: {},
            profileData: {},
            dynamicFormKey: 0,
            shipping_method: {},
            formErrors: [],
            disableInput: false
        }
    },
    filters: {
        dateFilter: function (timestamp) {
            return moment(timestamp).format('L LTS')
        }
    },
    methods: {
        updateSettings(newFormSettings, settingsGrouping, errors) {
            var formSettingsCopy = this.shipping_method
            var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
            this.formErrors = errors

            if (this.customFormMode == 3) {
                this.errors = errors
            }

            this.shipping_method = mergedHash
        },
        isJsonString(str) {
            try {
                var json = JSON.parse(str);
                return (typeof json === 'object');
            } catch (e) {
                return false;
            }
        },
        openDetails() {
            this.showDetails = true
        },
        openHistory() {
            this.showDetails = false
        },
        validateForm() {
            this.errors = [];
            // this.errors.push(ValidateField.required('Code', this.inputCode));
            this.errors.push(ValidateField.required('Name', this.inputName));
            this.errors.push(ValidateField.required('Shipping Type', this.inputShippingType));
            this.errors.push(ValidateField.required('Carrier', this.inputCarrier));
            this.errors.push(ValidateField.required('Carrier Account', this.inputCarrierAccount));
            this.errors.push(ValidateField.required('Contact Person', this.inputContactPerson));
            this.errors.push(ValidateField.charMinAndMax('Contact Person', this.inputContactPerson, 0, 200));
            this.errors.push(ValidateField.alphabetWithSpace('Contact Person', this.inputContactPerson));
            this.errors.push(ValidateField.phoneNumberFormat('Phone', this.inputPhone));
            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        create: async function () {
            if (!this.validateForm()) {
                var shippingMethodPayload = {
                    shipping_method: {
                        name: this.inputName.trim(),
                        code: this.inputCode.trim(),
                        shipping_type: this.inputShippingType,
                        carrier: this.inputCarrier,
                        carrier_account: this.inputCarrierAccount,
                        contact_person: this.inputContactPerson,
                        phone: this.inputPhone,
                        remark: this.inputRemark
                    }
                }
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'shipping_methods', null, shippingMethodPayload)
                if (post_request == undefined) {
                    this.$emit('refreshPage', event)
                } else {
                    if (post_request["error"] == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = post_request["error"].split(",") //format will change when error message has comma
                        document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                        //this.$router.push("/")
                    }
                }
            }
        },
        update: async function () {
            if (!this.validateForm()) {
                var shippingMethodPayload = {
                    shipping_method: {
                        name: this.inputName.trim(),
                        code: this.inputCode.trim(),
                        shipping_type: this.inputShippingType,
                        carrier: this.inputCarrier,
                        carrier_account: this.inputCarrierAccount,
                        contact_person: this.inputContactPerson,
                        phone: this.inputPhone,
                        remark: this.inputRemark
                    }
                }
                var put_request = await HTTPRequest.putRequest(this.endPoint + 'shipping_methods/' + this.profileId, null, shippingMethodPayload)
                if (put_request == undefined) {
                    this.$emit('refreshPage', event)
                } else {
                    if (put_request["error"] == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = put_request["error"].split(",") //format will change when error message has comma
                        document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                        //this.$router.push("/")
                    }
                }
            }

        }
    }
}
</script>

<style>
</style>
